var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.latestMessage
    ? _c(
        "div",
        { attrs: { role: "main" } },
        [
          _c("div", { staticClass: "row header-links" }, [
            _c(
              "h1",
              { staticClass: "col mb-sm-3 mb-0", attrs: { tabindex: "-1" } },
              [_vm._v(_vm._s(_vm.$t("Correspondence.Title")))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-auto" }, [
              !_vm.downloadingPdf
                ? _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top.center",
                          value: {
                            content: _vm.$t("Btn_Pdf_Generic_Description")
                          },
                          expression:
                            "{ content:$t('Btn_Pdf_Generic_Description') }",
                          modifiers: { top: true, center: true }
                        }
                      ],
                      staticClass: "btn btn-secondary float-right",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.generatePdf()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.$t("Btn_Pdf")) + "\n        "
                      ),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v(
                          "-. " + _vm._s(_vm.$t("Btn_Pdf_Generic_Description"))
                        )
                      ])
                    ]
                  )
                : _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip.top.center",
                          value: {
                            content: _vm.$t("Btn_Pdf_Generic_Description")
                          },
                          expression:
                            "{ content: $t('Btn_Pdf_Generic_Description') }",
                          modifiers: { top: true, center: true }
                        }
                      ],
                      staticClass: "d-inline-block float-right",
                      attrs: { tabindex: "0" }
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: {
                            type: "button",
                            disabled: "",
                            "aria-disabled": true
                          }
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.$t("Btn_Pdf")) +
                              "\n          "
                          ),
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v(
                              "-. " +
                                _vm._s(_vm.$t("Btn_Pdf_Generic_Description"))
                            )
                          ])
                        ]
                      )
                    ]
                  )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-block d-sm-none" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h2", { staticClass: "mb-2 mt-2" }, [
                  _vm._v(_vm._s(_vm.latestMessage.header))
                ])
              ])
            ]),
            _vm._v(" "),
            _vm.correspondence.procurationOnly
              ? _c("div", { staticClass: "row mb-4" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("span", [
                      _c("i", {
                        staticClass: "fas fa-exclamation-circle fa-lg"
                      }),
                      _vm._v(" "),
                      _c("i", [
                        _vm._v(_vm._s(_vm.$t("Correspondence.ProcuratorOnly")))
                      ])
                    ])
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-none d-sm-block" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-8" }, [
                _c("h2", [_vm._v(_vm._s(_vm.latestMessage.header))])
              ]),
              _vm._v(" "),
              _vm.correspondence.procurationOnly
                ? _c("div", { staticClass: "col-4" }, [
                    _c("span", { staticClass: "float-right" }, [
                      _c("i", {
                        staticClass: "fas fa-exclamation-circle fa-lg"
                      }),
                      _vm._v(" "),
                      _c("i", [
                        _vm._v(_vm._s(_vm.$t("Correspondence.ProcuratorOnly")))
                      ])
                    ])
                  ])
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _vm.correspondence.aidtargetNumber
            ? _c("text-label-row", {
                attrs: {
                  title: "AidTargetNumber",
                  labelClass: "col-5 col-sm-3 col-md-2",
                  valueClass: "col-7",
                  value: _vm.correspondence.aidtargetNumber
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.correspondence.aidTargetSpecification
            ? _c("text-label-row", {
                attrs: {
                  title: "Correspondence.OperationOrPurpose",
                  labelClass: "col-5 col-sm-3 col-md-2",
                  valueClass: "col-7",
                  value: _vm.correspondence.aidTargetSpecification
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("text-label-row", {
            attrs: {
              title: "State",
              labelClass: "col-5 col-sm-3 col-md-2",
              valueClass: "col-7",
              value: _vm.getDisplayState(_vm.correspondence.state)
            }
          }),
          _vm._v(" "),
          _c("ValidationObserver", {
            ref: "correspondenceObserver",
            attrs: { slim: "" },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(ref) {
                    var invalid = ref.invalid
                    var validate = ref.validate
                    return [
                      !_vm.loading || _vm.validateForm(!invalid)
                        ? _c(
                            "form",
                            {
                              attrs: { id: "correspondenceForm" },
                              on: {
                                submit: function($event) {
                                  $event.preventDefault()
                                  return _vm.send()
                                }
                              }
                            },
                            [
                              _c(
                                "ul",
                                {
                                  staticClass: "p-0 mt-3 mb-4 accordion",
                                  attrs: {
                                    "aria-label": _vm.$t(
                                      "Correspondence.Accessibility.Messages"
                                    )
                                  }
                                },
                                _vm._l(_vm.correspondence.messages, function(
                                  message,
                                  index
                                ) {
                                  return _c(
                                    "li",
                                    { key: index, staticClass: "card" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          class: [
                                            index == 0 ? "" : "collapsed",
                                            "card-header"
                                          ],
                                          attrs: {
                                            type: "button",
                                            id: "heading-" + index,
                                            "data-toggle": "collapse",
                                            "data-target": "#collapse" + index,
                                            "aria-controls": "collapse" + index,
                                            "aria-expanded":
                                              index == 0 ? "true" : "false"
                                          }
                                        },
                                        [
                                          _c("div", { staticClass: "row" }, [
                                            _c(
                                              "h3",
                                              { staticClass: "col-12" },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-envelope fa-lg mr-2 float-left"
                                                }),
                                                _vm._v(" "),
                                                _vm.isFromStea(message)
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "float-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "Correspondence.Received"
                                                            )
                                                          ) +
                                                            ": " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatDate"
                                                              )(
                                                                message.sentDate
                                                              )
                                                            )
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !_vm.isFromStea(message)
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "float-left"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "Correspondence.Sent"
                                                            )
                                                          ) +
                                                            ": " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "formatDate"
                                                              )(
                                                                message.sentDate
                                                              )
                                                            )
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-plus fa-lg float-right"
                                                }),
                                                _vm._v(" "),
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-minus fa-lg float-right"
                                                })
                                              ]
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          class: {
                                            collapse: true,
                                            show: index === 0
                                          },
                                          attrs: {
                                            id: "collapse" + index,
                                            "aria-labelledby":
                                              "heading-" + index
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "card-body" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _vm.showDeadline(index)
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass: "col-6"
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              class: [
                                                                _vm.isPastDeadline(
                                                                  message.deadline
                                                                )
                                                                  ? "past-deadline deadline"
                                                                  : "deadline"
                                                              ]
                                                            },
                                                            [
                                                              _vm.isPastDeadline(
                                                                message.deadline
                                                              )
                                                                ? _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "toUpperCase"
                                                                        )(
                                                                          _vm.$t(
                                                                            "PastDeadline"
                                                                          )
                                                                        )
                                                                      )
                                                                    )
                                                                  ])
                                                                : _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "toUpperCase"
                                                                        )(
                                                                          _vm.$t(
                                                                            "Deadline"
                                                                          )
                                                                        )
                                                                      )
                                                                    )
                                                                  ]),
                                                              _vm._v(" "),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "formatDate"
                                                                    )(
                                                                      message.deadline
                                                                    )
                                                                  )
                                                                )
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _vm.canBeAnswered(index) &&
                                                  !_vm.isAnswerPanelVisible
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass: "col-6"
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              class: [
                                                                _vm.isAnswerPanelVisible
                                                                  ? "btn-default"
                                                                  : "btn-secondary",
                                                                "btn float-right"
                                                              ],
                                                              attrs: {
                                                                type: "button",
                                                                disabled:
                                                                  _vm.isAnswerPanelVisible,
                                                                "aria-disabled":
                                                                  _vm.isAnswerPanelVisible
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.showAnswerPanel()
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "Btn_Answer"
                                                                    )
                                                                  ) +
                                                                  "\n                  "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              ),
                                              _vm._v(" "),
                                              index === 0 &&
                                              _vm.isAnswerPanelVisible
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass: "well mt-3"
                                                    },
                                                    [
                                                      _c("label-control", {
                                                        staticClass: "mb-0",
                                                        attrs: {
                                                          forElement:
                                                            "correspondencemessage",
                                                          title:
                                                            "Correspondence.Message",
                                                          required: true
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        { staticClass: "ml-2" },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fas fa-exclamation-circle fa-lg"
                                                          }),
                                                          _vm._v(" "),
                                                          _c("i", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "Correspondence.EditSaveNotAllowed"
                                                                )
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("text-area-row", {
                                                        attrs: {
                                                          required: true,
                                                          id:
                                                            "correspondencemessage",
                                                          maxLength:
                                                            _vm.messageMaxLength,
                                                          rows: 7
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.newMessage
                                                              .message,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.newMessage,
                                                              "message",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "newMessage.message"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("attachment-table", {
                                                        attrs: {
                                                          id:
                                                            "attachments-" +
                                                            index,
                                                          attachmentNameMaxLength:
                                                            _vm.attachmentNameMaxLength,
                                                          validateImmediately: true
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.newMessage
                                                              .attachments,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.newMessage,
                                                              "attachments",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "newMessage.attachments"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        { staticClass: "mt-3" },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn-secondary",
                                                              attrs: {
                                                                type: "button"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.send()
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "Btn_SendAnswer"
                                                                    )
                                                                  ) +
                                                                  "\n                  "
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "btn btn-negative",
                                                              attrs: {
                                                                type: "button"
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.hideAnswerPanel()
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                    " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "Btn_Cancel"
                                                                    )
                                                                  ) +
                                                                  "\n                  "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "row mt-3 mb-3"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "col-12" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "white-space":
                                                              "pre-wrap"
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              message.message
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.isFromStea(message)
                                                ? _c(
                                                    "div",
                                                    { staticClass: "row mt-3" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col-12"
                                                        },
                                                        [
                                                          _c(
                                                            "i",
                                                            {
                                                              staticClass:
                                                                "float-right"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "-- " +
                                                                  _vm._s(
                                                                    message.senderName
                                                                  )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "sr-only"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "Correspondence.Accessibility.Sender"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.showAttachments(message)
                                                ? _c(
                                                    "div",
                                                    { staticClass: "row mt-4" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass: "col-12"
                                                        },
                                                        [
                                                          _c(
                                                            "h4",
                                                            {
                                                              attrs: {
                                                                id:
                                                                  "Attachment.Attachments"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "Attachment.Attachments"
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "ul",
                                                            {
                                                              attrs: {
                                                                "aria-labelledby":
                                                                  "Attachment.Attachments"
                                                              }
                                                            },
                                                            _vm._l(
                                                              message.attachments,
                                                              function(item) {
                                                                return _c(
                                                                  "li",
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.name
                                                                      ) +
                                                                        ": " +
                                                                        _vm._s(
                                                                          _vm.getAttachmentFileName(
                                                                            item
                                                                          )
                                                                        )
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  }
                }
              ],
              null,
              false,
              2334084302
            )
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }